import React from 'react';

import {hooks} from '../hooks';
import {FeeKindDetailsType} from '../types';
import rowCenterSpcBtw from '../utils/rowCenterSpcBtw';
  
type Props = {
  index: number;
  feeKind: FeeKindDetailsType;
  isLast: boolean;
};

export const FeeKindDetailsItem: React.FC<Props> = ({feeKind}) => {
  const navigate = hooks.useNavigate();

  return (
    <>
    <div
      style={{
        padding: 14,
        paddingTop: 14,
        paddingBottom: 14,
        borderRadius: 10,
        position: 'relative',
        marginBottom: 14,
        backgroundColor: 'var(--white-color)',
        display: 'block',
        maxWidth: '100%',
        height: 80,
        maxHeight: 80,
      }}
      onClick={() => navigate(`/dish/${feeKind.id}`, {state: {feeKind}})}
    >
      <div className="row-center-space-between">  
        <h5 className='number-of-lines-2' style={{marginBottom: 10, padding: '6px 0'}}>{feeKind.name}</h5>
        <h5 className='number-of-lines-2' style={{marginBottom: 10, padding: '6px 0'}}>Rp. {feeKind.months.find(m => m.month === 'January')?.amount ?? 'N/A'}</h5>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div className='row-center-space-between'>
        <p 
          className='t12' 
          style={{
            backgroundColor: 'var(--main-turquoise)',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
            padding: '4px 8px',
          }}
        >
          <span style={{
            color: 'var(--white-color)',
            fontWeight: 600,
            fontSize: '12px',
          }}>{`${feeKind.months[0].status}`}
          </span>
        </p>
        <p
          className='t10'
          style={{lineHeight: 1.2, textAlign: 'right', right: 20}}
        >
          {`${feeKind.months[0].month}`}
        </p>
      </div>
    </div>
    </>
  );
};
